<template>
    <component :is="'attr-' + editActiveElement.elName" v-bind="{...editActiveElement.commonStyle, ...editActiveElement.propsValue}"></component>
</template>

<script>
	import attrComponents from './index.js'
	import {mapState, mapGetters} from 'vuex'

	export default {
		components: {
			...attrComponents
		},
		computed: {
			...mapState({
                editActiveElement: state => state.editor.editActiveElement,
			})
		},
	}
</script>

<style scoped>

</style>
